/* eslint-disable simple-import-sort/imports */
import Lenis from '@studio-freight/lenis';
import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { styled } from 'styled-components';
import { SITE_NAME } from 'constants';

import FooterV2 from './components/FooterV2';
import Nav from './components/Nav';
import ContactV2 from './sections/ContactV2';
import FaqV2 from './sections/FaqV2';
import FeaturesV2 from './sections/FeaturesV2';
import FoundersV2 from './sections/FoundersV2';
import HeroV2 from './sections/HeroV2';
import LogoWall from './sections/LogoWall';
// import TestimonialsV2 from './sections/TestimonialsV2'; // vorübergehend deaktiviert – kommt in neuer Version zurück
import VideoV2 from './sections/VideoV2';
import {
  HOME_DESCRIPTION,
  HOME_TITLE,
  HOME_URL,
  homeStructuredData,
  LOGO_URL,
} from './seo';
import { Grain, v2, V2GlobalStyle } from './v2';

const Main = styled.main`
  background: ${v2.bg};
  color: ${v2.text};
  overflow-x: clip;
`;

const HomeV2 = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.4 });
    lenisRef.current = lenis;
    if (process.env.NODE_ENV === 'development') {
      window.__lenis = lenis;
    }
    let raf;

    function frame(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(frame);
    }

    raf = requestAnimationFrame(frame);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = (target) => {
    if (target === 'top') {
      if (lenisRef.current) {
        lenisRef.current.scrollTo(0, { duration: 1.6 });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    const el = document.getElementById(target);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -70, duration: 1.6 });
    } else {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Helmet>
        <title>{HOME_TITLE}</title>
        <meta name="description" content={HOME_DESCRIPTION} />
        <link rel="canonical" href={HOME_URL} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="de_DE" />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:url" content={HOME_URL} />
        <meta property="og:title" content={HOME_TITLE} />
        <meta property="og:description" content={HOME_DESCRIPTION} />
        <meta property="og:image" content={LOGO_URL} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={HOME_TITLE} />
        <meta name="twitter:description" content={HOME_DESCRIPTION} />
        <script type="application/ld+json">
          {JSON.stringify(homeStructuredData)}
        </script>
      </Helmet>
      <V2GlobalStyle />
      <Grain aria-hidden />
      <Nav onNavigate={scrollTo} />
      <Main>
        <HeroV2 />
        <LogoWall />
        <VideoV2 />
        <FeaturesV2 />
        <FoundersV2 />
        {/* Sektion "Stimmen unserer Kunden" – vorübergehend deaktiviert, kommt in neuer Version zurück */}
        {/* <TestimonialsV2 /> */}
        <FaqV2 />
        <ContactV2 />
      </Main>
      <FooterV2 />
    </>
  );
};

export default HomeV2;
